export default "__VITE_ASSET__CJYtAfQc__"